import { Helmet } from "react-helmet-async";
import { SITE_NAME, absUrl } from "@/lib/seo";

/**
 * Per-page SEO head tags (title, description, canonical, Open Graph, Twitter, JSON-LD).
 * Rendered via react-helmet-async so each route gets unique, crawlable metadata.
 * This only writes to <head> — it renders nothing visible.
 */
export default function Seo({ title, description, canonical, image, type = "website", jsonLd = null, noindex = false }) {
    const fullTitle = title
        ? (title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`)
        : SITE_NAME;
    const url = canonical ? absUrl(canonical) : undefined;
    const img = image || absUrl("/og-image.png");
    const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {url && <link rel="canonical" href={url} />}
            {noindex && <meta name="robots" content="noindex,follow" />}

            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            {url && <meta property="og:url" content={url} />}
            <meta property="og:image" content={img} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={img} />

            {blocks.map((obj, i) => (
                <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
            ))}
        </Helmet>
    );
}
